'use strict';

/* InView adds functions to components based on their scrols locations
 To use: Extend "InView" in your page JS. Attach data-in-view to elements you want to watch. Then watch the element for InView's triggers.
 eg.
  myElement.bind('inViewCenter', function() {
    this.addClass('my-element--in-view')
  });
*/

function InView() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_ResponsiveLayout];

  this.$in_view_elements = $('[data-in-view]', this.node);

  this.init = function () {
    this.$window = $(window);
    this.$navigation = $('#Navigation');

    if (this.$in_view_elements.length) {
      this.$window.on('scroll', Throttle(function (event) {
        this._inView();
      }).bind(this));

      this.$window.trigger('scroll');
      this.registerResponsiveFunction(this._inView.bind(this), null, null);
    }
  };

  this.initAllReady = function () {
    if (this.$in_view_elements.length) {
      this.$window.trigger('scroll');
    }
  };

  this._inView = function () {
    var windowHeight = this.$window.height();
    var windowTopPosition = this.$window.scrollTop();
    var windowTopOffset = windowTopPosition + this.$navigation.outerHeight();
    var windowBottomPosition = windowTopPosition + windowHeight;
    var windowMiddlePosition = windowTopOffset + windowHeight / 2;

    $.each(this.$in_view_elements, function () {
      var $element = $(this);
      var elementTopPosition = $element.offset().top;
      var elementHeight = $element.outerHeight();
      var elementBottomPosition = elementTopPosition + elementHeight;
      var elementMiddlePosition = elementTopPosition + elementHeight / 2;

      // Check if the element is in view at the bottom of the window
      if (elementTopPosition <= windowBottomPosition) {
        $element.trigger('inViewBottom');
      } else {
        $element.trigger('outOfViewBottom');
      }

      // Check if the element is in the upper half of the window
      if (elementTopPosition <= windowMiddlePosition) {
        $element.trigger('inViewCenter');
      }

      // Check if the element is at the top of the window
      if (elementTopPosition <= windowTopOffset) {
        $element.trigger('inViewTop');
      } else {
        $element.trigger('outOfViewTop');
      }

      // Check if the top half of the element has been scrolled off the top of the screen
      if (elementMiddlePosition <= windowTopOffset) {
        $element.trigger('outOfViewHalfScrolledPast');
      }

      // Check if the bottom of the element is in the bottom of the window
      if (elementBottomPosition <= windowBottomPosition) {
        $element.trigger('inViewElementBottom');
      }

      // General check for if the element is in view or not
      if (elementTopPosition <= windowBottomPosition) {
        $element.trigger('inView');
      } else {
        $element.trigger('outOfView');
      }

      if (windowTopPosition > elementBottomPosition) {
        $element.trigger('outOfView');
      }

      // Check if the element is in view but offset by 50%
      if (elementMiddlePosition <= windowBottomPosition) {
        $element.trigger('inViewOffset');
      } else {
        $element.trigger('outOfViewOffset');
      }

      if (windowTopPosition > elementMiddlePosition) {
        $element.trigger('outOfViewOffset');
      }
    });
  };
}